import {
    createContext, FC, useState,
} from 'react';
import { useParams } from 'react-router-dom';
import { deleteConcept, getConcepts } from '../../../api/payments';
import { IConcept } from '../../../interfaces/plan';
import { EConceptType } from '../enums/types.enum';

interface IMRRConceptContext {
    concepts: any[],
    loading: boolean,
    fetchConcepts: () => void,
    addConcept: (concept: any) => void,
    removeConcept: (planId: string, conceptId: string) => void,
}

const initialContext = {
    concepts: [],
    loading: false,
    fetchConcepts: () => {},
    addConcept: (concept: any) => {},
    removeConcept: (planId: string, conceptId: string) => {},
};

export const MRRConceptsContext = createContext<IMRRConceptContext>(initialContext);

export const MRRConceptsProvider: FC = ({ children }) => {
    const [loading, setLoading] = useState<boolean>(initialContext.loading);
    const [concepts, setConcepts] = useState<IConcept[]>(initialContext.concepts);

    const [type] = useState<EConceptType>(EConceptType.MRR);

    const { id } = useParams();

    const fetchConcepts = () => {
        if (!id) return;
        setLoading(true);
        getConcepts(id, type)
            .then(({ data }) => {
                setConcepts(data.data.data);
            })
            .catch()
            .finally(() => setLoading(false));
    };

    const addConcept = (concept: any) => {
        const exists = concepts.find((c: any) => c._id === concept._id);
        if (exists) {
            setConcepts((concepts: any) => concepts.map((c: any) => {
                if (c._id === concept._id) return concept;
                return c;
            }));
        } else {
            setConcepts((concepts: any) => [...concepts, concept]);
        }
    };

    const removeConcept = async (planId: string, conceptId: string) => {
        setLoading(true);
        deleteConcept(planId, conceptId)
            .then(() => {
                setConcepts((concepts: any) => concepts.filter((c: any) => c._id !== conceptId));
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => setLoading(false));
    };

    return (
        <MRRConceptsContext.Provider
            value={{
                concepts,
                loading,
                fetchConcepts,
                addConcept,
                removeConcept,
            }}
        >
            {children}
        </MRRConceptsContext.Provider>
    );
};
